import { ReactNode } from 'react';
import { ThemeProvider } from '@/hooks/useTheme';
import { Header } from './Header';
import { Footer } from './Footer';
import { ArcadeFAB } from './ArcadeFAB';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <ThemeProvider>
      <div className="relative flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
        <ArcadeFAB />
      </div>
    </ThemeProvider>
  );
}
